import { mainStartUp } from "./js/main.js";
import { analyticsInit } from "./js/analytics.js";
import { controlStartUp } from "./js/control.js";
import { onBrowserTooltip } from "./js/browser.js";
import { tagsDynamicFetch } from "./js/tags.js";
import {
  mapInit,
  mapFetchPosters,
  mapRadioLabelFilterChange,
} from "./js/map.js";
import { mapsPrefetchVegueries } from "./js/maps.js";
import { Log } from "./js/log.js";
import { empOnClickLink, empEditorWakeUp } from "./js/emp.js";
import { posterRender, posterParseDocument } from "./js/poster.js";
import { linksCreate } from "./js/links.js";
import { adsensePushFullAds } from "./js/adsense.js";
import {
  subscriptionSendNewConnection,
  subscriptionLoadForm,
} from "./js/subscription.js";
import { weekendStartUp } from "./js/weekend.js";
import { seoLabelStartUp } from "./js/seo-label.js";
import { headerInit } from "./js/header.js";
import { IfQuickReloadFlushEverything } from "./js/cache.js";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", headerInit, {once: true});
} else {
  headerInit();
}

function startMain(label = null, town = null, regions = null, vegueria = null) {
  mainStartUp(label, town, regions, vegueria);
  analyticsInit();
  controlStartUp("mainSentinel");
  tagsDynamicFetch();
  subscriptionLoadForm();
  subscriptionSendNewConnection();
  empEditorWakeUp();
}

async function startPage() {
  if (await IfQuickReloadFlushEverything()) {
    return;
  }
  mapsPrefetchVegueries().finally(() => {
    analyticsInit();
    posterRender();
    posterParseDocument();
    tagsDynamicFetch();
    subscriptionLoadForm();
    subscriptionSendNewConnection();
    empEditorWakeUp();
  });
}

function startLinks() {
  mapsPrefetchVegueries().finally(() => {
    linksCreate("posterLinksWrapper");
    controlStartUp("posterSentinel");
  });
}

function startList() {
  analyticsInit();
}

function startMap() {
  mapsPrefetchVegueries().finally(() => {
    Log.init();
    mapInit();
    tagsDynamicFetch();
    mapFetchPosters(document.getElementById("mapWindowInfo"));
    analyticsInit();
    subscriptionLoadForm();
  });
}

function startMenu() {
    mapsPrefetchVegueries().finally(() => {
      analyticsInit();
      tagsDynamicFetch();
      subscriptionLoadForm();
    });
}

function startWeekend(vegueria = "", town = "") {
  mapsPrefetchVegueries().finally(() => {
    weekendStartUp(vegueria, town);
    tagsDynamicFetch();
    subscriptionLoadForm();
    subscriptionSendNewConnection();
    empEditorWakeUp();
    analyticsInit();
  });
}

function startSeoLabel(vegueria = "", town = "") {
  mapsPrefetchVegueries().finally(() => {
    seoLabelStartUp(vegueria, town);
    tagsDynamicFetch();
    subscriptionLoadForm();
    subscriptionSendNewConnection();
    empEditorWakeUp();
    analyticsInit();
  });
}

window.startMain = startMain;
window.startPage = startPage;
window.startLinks = startLinks;
window.startList = startList;
window.startMap = startMap;
window.startMenu = startMenu;
window.startWeekend = startWeekend;
window.startSeoLabel = startSeoLabel;
window.empOnClickLink = empOnClickLink;
window.adsensePushFullAds = adsensePushFullAds;
window.mapRadioLabelFilterChange = mapRadioLabelFilterChange;
window.onBrowserTooltip = onBrowserTooltip;
window.analyticsInit = analyticsInit;
window.subscriptionLoadForm = subscriptionLoadForm;
